import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='publishableKey' subtitle='String?' mdxType="Item">
      <p>{`Set the `}<a parentName="p" {...{
          "href": "https://docs.stripe.com/keys#obtain-api-keys/"
        }}>{`Stripe publishable key`}</a>{`.`}</p>
    </Item>
    <Item title='mandateData' subtitle='MandateData?' mdxType="Item">
      <p>{`One of:`}</p>
      <Group mdxType="Group">
        <Item title='fullMandate(text:)' subtitle='MandateData' mdxType="Item">
          <p>{`The full `}<inlineCode parentName="p">{`text`}</inlineCode>{` that you would like to be displayed to the user before
they accept/decline the mandate.`}</p>
        </Item>
        <Item title='templateMandate(merchantName:)' subtitle='MandateData' mdxType="Item">
          <p>{`A `}<inlineCode parentName="p">{`merchantName`}</inlineCode>{` that will be used as part of our predefined mandate template. `}</p>
        </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      